function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { EventBoundary, useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import VisibilitySensor from 'react-visibility-sensor';
import MedianPriceCard from './median-price-card';
import ExploreCtaCard from './explore-cta-card';
import * as styles from './research-driver.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ResearchDriver = props => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visibilityEventSent = _useState2[0],
    setVisibilityEventSent = _useState2[1];
  return ___EmotionJSX(VisibilitySensor, {
    onChange: isVisible => {
      if (isVisible && !visibilityEventSent) {
        sendEvent('display-research-cta');
        setVisibilityEventSent(true);
      }
    }
  }, ___EmotionJSX("div", {
    css: styles.researchDriver
  }, ___EmotionJSX("h2", {
    css: styles.heading
  }, "Suburb profiles and past sales"), ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.cards
  }, ___EmotionJSX(ExploreCtaCard, null), props.medianPriceItems.map((item, listPosition) => ___EmotionJSX(EventBoundary, {
    data: {
      listPosition
    }
  }, ___EmotionJSX(MedianPriceCard, _extends({
    key: item.districtName
  }, item))))))));
};
ResearchDriver.propTypes = {
  medianPriceItems: PropTypes.arrayOf(PropTypes.shape({
    statistics: PropTypes.shape({
      housePrice: PropTypes.string,
      houseDelta: PropTypes.number,
      unitPrice: PropTypes.string,
      unitDelta: PropTypes.number
    }),
    districtName: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired
  }))
};
ResearchDriver.defaultProps = {
  medianPriceItems: []
};
export default ResearchDriver;